import { render, staticRenderFns } from "./WaitingValuesMobile.vue?vue&type=template&id=10a0ef2e&"
import script from "./WaitingValuesMobile.vue?vue&type=script&lang=js&"
export * from "./WaitingValuesMobile.vue?vue&type=script&lang=js&"
import style0 from "./WaitingValuesMobile.vue?vue&type=style&index=0&id=10a0ef2e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports